import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Grid,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Box,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import apiPrakasak from "../../api/apiPrakasak";
import MuiHeader from "../../components/MuiHeader";

function TopParent() {
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [clusters, setClusters] = useState([]);
  const [dropdownType, setDropdownType] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedBlock, setSelectedBlock] = useState("");
  const [selectedCluster, setSelectedCluster] = useState("");
  const [selectedName, setSelectedName] = useState("");
  const [nameOptions, setNameOptions] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    const fetchDistricts = async () => {
      setLoading(true);
      try {
        const response = await apiPrakasak.get("/getAllDistricts");
        if (response?.data) {
          setDistricts(response.data.map((item) => item.district));
        }
      } catch (error) {
        toast.error("Failed to fetch districts.");
      } finally {
        setLoading(false);
      }
    };
    fetchDistricts();
  }, []);

  useEffect(() => {
    if (!selectedDistrict) return;
    const fetchBlocks = async () => {
      setLoading(true);
      try {
        const response = await apiPrakasak.get(
          `/getAllBlocksByDistrict/${selectedDistrict}`
        );
        setBlocks(response.data.map((item) => item.block));
      } catch (error) {
        toast.error("Failed to fetch blocks.");
      } finally {
        setLoading(false);
      }
    };
    fetchBlocks();
  }, [selectedDistrict]);

  useEffect(() => {
    if (!selectedBlock) return;
    const fetchClusters = async () => {
      setLoading(true);
      try {
        const response = await apiPrakasak.get(
          `/getAllClustersByBlock/${selectedBlock}`
        );
        setClusters(response.data.map((item) => item.cluster));
      } catch (error) {
        toast.error("Failed to fetch clusters.");
      } finally {
        setLoading(false);
      }
    };
    fetchClusters();
  }, [selectedBlock]);

  useEffect(() => {
    if (!dropdownType || !selectedCluster) return;
    const fetchDropdownOptions = async () => {
      setLoading(true);
      try {
        const response = await apiPrakasak.get(
          dropdownType === "SCHOOL"
            ? `/getAllSchoolsByCluster/${selectedCluster}`
            : `/getAllAnganwadisByCluster/${selectedCluster}`
        );
        setNameOptions(response.data || []);
        console.log('====================================nameOptions',response.data);
      } catch (error) {
        toast.error("Failed to fetch dropdown options.");
      } finally {
        setLoading(false);
      }
    };
    fetchDropdownOptions();
  }, [dropdownType, selectedCluster]);

  const handleFetchData = async () => {
    // Validation: Ensure all fields are selected
    if (!selectedDistrict || !selectedBlock || !selectedCluster || !dropdownType || !selectedName) {
      toast.error("Please select all fields before submitting.");
      return;
    }

    setLoading(true);
    try {
      const response = await apiPrakasak.get(
        dropdownType === "SCHOOL"
          ? `/getTopParentsBySchool/${selectedName}`
          : `/getTopParentsByAnganwadi/${selectedName}`
      );
      if (response.data?.length === 0) {
        toast.info("No records found.");
      }
      setData(response.data || []);
      console.log('====================================',response.data);
      console.log();
      console.log('====================================');
    } catch (error) {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div style={{ padding: "20px" }}>
      <ToastContainer />
      <Box sx={{ mb: 3 }}>
        <Grid container spacing={2}>
          {/* District Dropdown */}
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel>District</InputLabel>
              <Select
                value={selectedDistrict}
                onChange={(e) => {
                  setSelectedDistrict(e.target.value);
                  setBlocks([]);
                  setClusters([]);
                  setNameOptions([]);
                  setSelectedBlock("");
                  setSelectedCluster("");
                  setSelectedName("");
                }}
              >
                {districts.map((district, index) => (
                  <MenuItem key={index} value={district}>
                    {district}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {/* Block Dropdown */}
          {selectedDistrict && (
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Block</InputLabel>
                <Select
                  value={selectedBlock}
                  onChange={(e) => {
                    setSelectedBlock(e.target.value);
                    setClusters([]);
                    setNameOptions([]);
                    setSelectedCluster("");
                    setSelectedName("");
                  }}
                >
                  {blocks.map((block, index) => (
                    <MenuItem key={index} value={block}>
                      {block}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          {/* Cluster Dropdown */}
          {selectedBlock && (
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Cluster</InputLabel>
                <Select
                  value={selectedCluster}
                  onChange={(e) => {
                    setSelectedCluster(e.target.value);
                    setNameOptions([]);
                    setSelectedName("");
                  }}
                >
                  {clusters.map((cluster, index) => (
                    <MenuItem key={index} value={cluster}>
                      {cluster}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          {/* Type Dropdown */}
          {selectedCluster && (
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Type</InputLabel>
                <Select
                  value={dropdownType}
                  onChange={(e) => setDropdownType(e.target.value.toUpperCase())}
                >
                  <MenuItem value="SCHOOL">School</MenuItem>
                  <MenuItem value="ANGANWADI">Anganwadi</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
          {/* Name Dropdown */}
          {dropdownType && (
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>
                  {dropdownType === "SCHOOL" ? "School Name" : "Anganwadi Name"}
                </InputLabel>
                <Select
                  value={selectedName}
                  onChange={(e) => setSelectedName(e.target.value)}
                >
                  {nameOptions.map((option, index) => (
                    <MenuItem key={index} value={option.school_name}>
                      {option.school_name?.toUpperCase()}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          {/* Submit Button */}
          {selectedName && (
            <Grid item xs={12} md={3}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleFetchData}
                disabled={loading}
                fullWidth
                style={{height:"55px"}}
              >
                {loading ? <CircularProgress size={24} /> : "Submit"}
              </Button>
            </Grid>
          )}
        </Grid>
      </Box>
{data.length >0 ? (<>
  <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sl. No.</TableCell>
              <TableCell>Parent Name</TableCell>
              <TableCell>Phone Number</TableCell>
              <TableCell>Anganwadi/School</TableCell>
              <TableCell>Block</TableCell>
              <TableCell>District</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <TableRow key={row._id}>
                  <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell>{row.parents_name}</TableCell>
                  <TableCell>{row.phone_number}</TableCell>
                  <TableCell>{row[dropdownType.toLowerCase() + "_name"]}</TableCell>
                  <TableCell>{row.block}</TableCell>
                  <TableCell>{row.district}</TableCell>

                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
</>):(
  <>
   <h1 style={{ color: "red",display:"flex",justifyContent:"center",marginTop:"20%" }}>
                          No Record Available
                        </h1></>
)}
      {/* Data Table */}
      

      {/* Pagination */}
      {/* <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /> */}
    </div>
  );
}

export default TopParent;
